<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Requisição Todos Materiais EPI
      </p>
    </div>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="texto-titulo-input">Unidade</div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade"
          :error="unidadeObrigatoria"
        ></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6" @click.capture="verificarUnidade">
        <div class="texto-titulo-input">Centro de Custo</div>

        <q-input
          v-model="centroCustoUsuario"
          dense
          outlined
          bg-color="brand-7"
          class="select input-new-design"
          disable
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6" @click.capture="verificarUnidade">
        <div class="texto-titulo-input">Saldo Estoque</div>
        <q-select
          v-model="saldo"
          dense
          outlined
          map-options
          emit-value
          option-value="value"
          option-label="label"
          :options="saldoOptionsFiltered"
          :disable="isSaldoSelectDisabled"
          :bg-color="isSaldoSelectDisabled ? 'brand-7' : undefined"
          class="select input-new-design"
        />
      </div>
      <div
        v-if="tipoRequisicao == 'balcao'"
        @click.capture="verificarUnidade"
        class="col-2 input-colaborador-container"
      >
        <div class="no-margin-no-padding titulo-input-unidade">
          Requisição Para
        </div>
        <q-select dense outlined v-model="requisicaoPara" :options="options" />
      </div>
    </div>

    <div v-if="unidade.id">
      <NovaRequisicaoTabelas
        :unidade="unidade.id"
        :filtroTipoRequisicao="filtroTipoRequisicao"
        :tipoRequisicao="tipoRequisicao"
        :materialTodosSaldo="true"
        :tipoSaldo="saldo"
        :isAll="true"
        :category="1"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import NovaRequisicaoTabelas from "../components/NovaRequisicaoTabelas.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  name: "NovaRequisicao",
  components: {
    NovaRequisicaoTabelas,
    ListaUnidadesSelect,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const ativo = ref(true);
    const unidadeObrigatoria = ref(false);
    const ativo2 = ref(false);
    const saldo = ref("");
    let unidade = ref("");
    let filtroTipoRequisicao = ref("all");
    const tipoRequisicao = ref("requisicaoMaterial");
    const centroCustoUsuario = ref(null);
    const options = ref([
      {
        label: "Colaborador",
        value: "colaborador",
      },
      {
        label: "Visitante",
        value: "visitante",
      },
    ]);
    let requisicaoPara = ref({
      label: options.value[0].label,
      value: options.value[0].value,
    });

    const temPermissaoComSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-com-saldo"
        ) || false
      );
    });

    const temPermissaoSemSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-sem-saldo"
        ) || false
      );
    });

    const isSaldoSelectDisabled = computed(() => {
      return temPermissaoComSaldo.value || temPermissaoSemSaldo.value;
    });

    const saldoOptionsFiltered = computed(() => {
      if (temPermissaoComSaldo.value) {
        return [{ label: "Com Saldo", value: "com-saldo" }];
      }
      if (temPermissaoSemSaldo.value) {
        return [{ label: "Sem Saldo", value: "sem-saldo" }];
      }
      return [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ];
    });

    const inicializarSaldoBasedoNasPermissoes = () => {
      if (temPermissaoComSaldo.value) {
        saldo.value = "com-saldo";
      } else if (temPermissaoSemSaldo.value) {
        saldo.value = "sem-saldo";
      } else {
        saldo.value =
          store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("staging-acciona")
            ? "com-saldo"
            : "";
      }
    };

    watch(
      () => unidade.value,
      (novoValor) => {
        if (novoValor?.id) {
          unidadeObrigatoria.value = false;
        }
      }
    );

    const verificarUnidade = (event) => {
      if (!unidade.value?.id) {
        event.stopPropagation();
        event.preventDefault();
        unidadeObrigatoria.value = true;
        quasar.notify({
          message: "O campo Unidade é obrigatório para seguir com a requisição",
          color: "negative",
          position: "bottom",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    const getCentroUsuario = async () => {
      let response = await store.dispatch("requisicao/userLogado");
      centroCustoUsuario.value = `${response.data.cost_center.code} - ${response.data.cost_center.name}`;
    };

    onMounted(() => {
      getCentroUsuario();
      inicializarSaldoBasedoNasPermissoes();
    });

    return {
      unidade,
      ativo,
      ativo2,
      filtroTipoRequisicao,
      tipoRequisicao,
      options,
      requisicaoPara,
      centroCustoUsuario,
      saldo,
      saldoOptionsFiltered,
      isSaldoSelectDisabled,
      unidadeObrigatoria,
      verificarUnidade,
    };
  },
};
</script>

<style scoped>
.ativo {
  color: white !important;
  background-color: #2d3e6e !important;
  border-radius: 3px;
}
.ativo2 {
  color: white !important;
  background-color: #2b5070 !important;
  border-radius: 3px;
}

@media only screen and (max-width: 768px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
  }

  .col-2,
  .col-md-2,
  .col-sm-6,
  .col-xs-6 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
  }

  .row.col-12.row-input-container.text-weight-bold.text-brand-5.q-mt-md.q-gutter-sm {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .input-unidade-container,
  .input-colaborador-container {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
    padding: 0;
  }

  .titulo-input-unidade,
  .texto-titulo-input {
    font-size: 12px !important;
    margin-bottom: 4px;
  }

  .input-new-design {
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .no-margin-no-padding {
    padding: 0;
    margin: 0;
  }

  .q-ml-sm {
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 635px) {
  .text-titulo {
    font-size: 14px;
  }
  .no-margin-no-padding {
    padding: 0;
    margin: 0;
  }
  .input-unidade-container {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .row-input-container {
    margin: 0;
  }
  .input-tipo-requisicao-container {
    margin-top: 20px;
    padding: 0;
    width: 100%;
  }
  .btn-container {
    margin: 20px 0 0 0;
    padding: 0;
  }
  .btn {
    margin: 0 8px 0 0;
    padding: 8px 10px 8px 5px;
    font-size: 10px !important;
    width: 171px;
    border-radius: 5px;
  }
  .input-colaborador-container {
    width: 100%;
    padding: 0;
    margin: 15px 0 0 0;
  }
  .titulo-input-unidade {
    font-size: 12px;
  }
  .titulo-input-tipo-requisicao {
    font-size: 12px;
  }
}

@media only screen and (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .q-page {
    padding: 8px !important;
  }

  .btn {
    margin: 0 8px 0 0;
    padding: 8px 10px 8px 5px;
    font-size: 9px !important;
    width: 150px;
    border-radius: 5px;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
